const STAGES = [
  { n: "01", label: "Land & Liaison" },
  { n: "02", label: "Civil & Piling" },
  { n: "03", label: "Mechanical Erection" },
  { n: "04", label: "Electrical & BoS" },
  { n: "05", label: "Testing & Commissioning" },
];

export default function ScopeRail({ slim = false, showCaption = true }) {
  return (
    <div data-testid="scope-rail">
      <div className={`ye-rail ${slim ? "ye-rail--slim" : ""}`} role="list" aria-label="Project execution stages">
        {STAGES.map(s => (
          <div className="ye-rail-node" key={s.n} role="listitem">
            <div className="ye-rail-dot" aria-hidden="true">{s.n}</div>
            <div className="ye-rail-label">{s.label}</div>
          </div>
        ))}
      </div>
      {showCaption && <p className="ye-rail-caption">One contractor. The full sequence.</p>}
    </div>
  );
}
